import { render, staticRenderFns } from "./GatEdit.vue?vue&type=template&id=4b32b859&scoped=true&"
import script from "./GatEdit.vue?vue&type=script&lang=js&"
export * from "./GatEdit.vue?vue&type=script&lang=js&"
import style0 from "./GatEdit.vue?vue&type=style&index=0&id=4b32b859&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32b859",
  null
  
)

export default component.exports